import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4572cb92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "biotech-list-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPageData, (item, i) => {
      return (_openBlock(), _createBlock(_component_el_row, { key: i }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (cItem, ci) => {
            return (_openBlock(), _createBlock(_component_el_col, {
              span: 6,
              key: ci
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  class: "biotech-image",
                  src: cItem.src,
                  onClick: ($event: any) => (_ctx.selectBiotech(cItem))
                }, null, 8, ["src", "onClick"]),
                _createElementVNode("p", null, _toDisplayString(cItem.name), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 2
      }, 1024))
    }), 128)),
    _createVNode(_component_el_pagination, {
      layout: "prev, pager, next",
      "page-size": _ctx.pageSize,
      total: _ctx.biotechListData.length,
      "current-page": _ctx.currentPage,
      onCurrentChange: _ctx.gotoPage
    }, null, 8, ["page-size", "total", "current-page", "onCurrentChange"])
  ]))
}